import { render, staticRenderFns } from "./AdminSlidersEdit.vue?vue&type=template&id=fd3a089a&"
import script from "./AdminSlidersEdit.vue?vue&type=script&lang=js&"
export * from "./AdminSlidersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports